export default "__VITE_ASSET__6203b0f9__"